import { Directive } from '@angular/core';

@Directive({
  selector: '[appPageLayoutContent],app-page-layout-content',
  host: {
    class: 'vex-page-layout-content',
  },
})
export class PageLayoutContentDirective {
  constructor() {}
}
